import React from 'react'
import { getProgramData } from '~shared/api/single-program-data/single-program-data'
import { cn } from '~shared/utils/cn'


export const HeroArchiveSection = ({ program }:{program: Awaited<ReturnType<typeof getProgramData>>}) => {
  return (
    <section className='2lg:max-w-[1248px] md:max-w-[832px] mx-auto px-[16px] box-border'>
      <div
        className={cn(
          ' text-[#8B8B8B] bg-[#F2F2F2] rounded-[24px] p-[24px] pb-[70px]',
          '2lg:px-[60px] 2lg:py-[55px] 2lg:gap-[150px]',
          'md:p-[40px] md:gap-[50px] md:flex md:pb-[55px] md:bg-right',
          "bg-[url('/assets/imgs/archive-page/hero-archive-bg.png')] bg-no-repeat bg-cover bg-bottom"
        )}>
        <div className='2lg:max-w-[550px] md:max-w-[380px]'>
          <h1
            className={cn(
              'font-medium',
              '2lg:text-[64px] md:text-[48px] mb-[16px] md:mb-[24px] mt-0'
            )}>
            {program?.name}
          </h1>
          <p className='leading-[120%]'>{program?.description}</p>
        </div>
        <div className='relative h-fit w-fit mt-[22px] 2lg:mt-[100px] md:mt-[50px] z-10'>
          <img
            className='2lg:block hidden absolute w-[110px] left-[-100px] top-[-50px] -z-10'
            src='/assets/imgs/archive-page/sign.png'
          />
          <p
            className={cn(
              'text-[#8B8B8B] font-medium max-w-[190px]  tracking-tighter bg-white p-[16px] rounded-[24px] text-[20px]',
              '2lg:text-[32px]',
              'md:text-[24px] md:p-[24px] md:max-w-[250px]'
            )}>
            набор на&nbsp;программу закрыт
          </p>
          <img
            className={cn(
              'absolute w-[90px] top-[70px] right-[-10px]',
              'md:w-[100px] md:right-[-10px] md:top-[90px]',
              '2lg:w-[140px] 2lg:right-[-80px]'
            )}
            src='/assets/imgs/archive-page/archive-arrow.png'
          />
        </div>
      </div>
    </section>
  )
}
